export function calcularOleosIndicados(
  respostas: Record<string, boolean>,
  condicoes: string[]
): { oleos: string[], alertas: string[] } {
  const oleosSet = new Set<string>()
  const alertas: string[] = []

  // Mapeamento de respostas para óleos
  const mapeamento: Record<string, string[]> = {
    'sono': ['Lavanda'],
    'disposicao': ['Hortelã-Pimenta'],
    'foco': ['Limão Siciliano', 'Hortelã-Pimenta'],
    'memoria': ['Olíbano'],
    'ansiedade': ['Mix para Estabilidade', 'Copaíba', 'Tangerina'],
    'peso': ['Mix Metabólico', 'Tangerina', 'Limão Siciliano'],
    'dores': ['Hortelã-Pimenta', 'Mix para Tensão e Dores', 'Copaíba'],
    'medicamentos': ['Copaíba', 'Olíbano', 'Mix para Estabilidade'],
    'inflamacoes': ['Copaíba', 'Olíbano'],
    'intestino': ['Mix Digestivo'],
    'vergonha': ['Copaíba', 'Mix Imunidade'],
    'culpa': ['Copaíba', 'Limão Siciliano', 'Hortelã-Pimenta'],
    'apatia': ['Mix Imunidade', 'Tangerina'],
    'tristeza': ['Mix Respiratório', 'Tangerina', 'Hortelã-Pimenta'],
    'medo': ['Mix para Estabilidade', 'Lavanda', 'Hortelã-Pimenta'],
    'escassez': ['Mix para Estabilidade', 'Tangerina', 'Limão Siciliano'],
    'raiva': ['Mix para Estabilidade'],
    'orgulho': ['Mix Respiratório', 'Hortelã-Pimenta'],
    'estagnacao': ['Mix para Estabilidade', 'Mix Imunidade', 'Hortelã-Pimenta'],
    'desequilibrio': ['Mix para Estabilidade', 'Copaíba', 'Olíbano', 'Hortelã-Pimenta', 'Tangerina'],
  }

  // Adicionar óleos baseado nas respostas
  Object.entries(respostas).forEach(([key, value]) => {
    if (value && mapeamento[key]) {
      mapeamento[key].forEach(oleo => oleosSet.add(oleo))
    }
  })

  // Aplicar regras especiais de condições de saúde
  const temGestanteOuAmamentando = condicoes.some(c => c === 'Gestante' || c === 'Amamentando')
  const temEpilepsia = condicoes.includes('Epilepsia')
  const temHipertensao = condicoes.includes('Hipertensa(o)')

  if (temGestanteOuAmamentando) {
    oleosSet.clear()
    oleosSet.add('Lavanda')
    oleosSet.add('Tangerina')
    oleosSet.add('Limão Siciliano')
    alertas.push('Pela sua condição, é necessário avaliar seu protocolo de forma mais detalhada e individual. Os óleos indicados são os seguros neste momento. Entre em contato para orientação personalizada.')
  } else if (temEpilepsia) {
    oleosSet.clear()
    oleosSet.add('Mix para Aterramento')
    oleosSet.add('Tangerina')
    oleosSet.add('Mix Respiratório')
    oleosSet.add('Lavanda')
    alertas.push('Protocolo restrito aos óleos seguros para sua condição. Avaliação individual é fundamental.')
  } else {
    // Outras condições especiais
    if (temHipertensao && oleosSet.has('Hortelã-Pimenta')) {
      oleosSet.delete('Hortelã-Pimenta')
      alertas.push('Hortelã-Pimenta foi removida do seu protocolo por conta da hipertensão.')
    }

    if (condicoes.includes('Depressão') || condicoes.includes('Ansiedade crônica')) {
      oleosSet.add('Copaíba')
      oleosSet.add('Olíbano')
      oleosSet.add('Mix para Estabilidade')
      oleosSet.add('Lavanda')
      if (!temHipertensao) {
        oleosSet.add('Hortelã-Pimenta')
        oleosSet.add('Tangerina')
      }
    }

    if (condicoes.includes('Alergias respiratórias')) {
      oleosSet.add('Mix Respiratório')
    }

    if (condicoes.includes('Sensibilidade na pele')) {
      oleosSet.add('Melaleuca')
      oleosSet.add('Copaíba')
      oleosSet.add('Lavanda')
    }

    if (condicoes.includes('Hiperatividade') || condicoes.includes('TDAH')) {
      oleosSet.add('Mix para Estabilidade')
      oleosSet.add('Copaíba')
    }

    if (condicoes.includes('Autismo')) {
      oleosSet.add('Mix para Aterramento')
    }

    if (condicoes.includes('Doença autoimune')) {
      oleosSet.add('Copaíba')
      oleosSet.add('Olíbano')
      oleosSet.add('Mix para Estabilidade')
      oleosSet.add('Lavanda')
      oleosSet.add('Mix Digestivo')
      alertas.push('Protocolo de suporte incluído. Recomendamos acompanhamento individualizado.')
    }

    if (condicoes.includes('Endometriose') || condicoes.includes('Menopausa')) {
      oleosSet.add('Mix Mensal Feminino')
    }
  }

  return {
    oleos: Array.from(oleosSet),
    alertas,
  }
}
